module.exports = __webpack_public_path__ + "img/maps-and-flags.5588985a.svg";